<div class="flex">
  <sbnb-subnav [header]="'GUESTXP.GUESTXP' | transloco">
    <sbnb-gx-subnav></sbnb-gx-subnav>
  </sbnb-subnav>

  <main class="flex-1 subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="mb-0">Upsells</h2>
      </sbnb-page-header>
      <h2 class="mb-10">Upsells</h2>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'upsells'"></sbnb-helptext-wrapper>

    <div
      (click)="navigateToMessagingRules()"
      *ngIf="!hasSmartUpsell && hasActiveProducts() && !loading"
      class="cursor-pointer mb-12 bg-blue-50 border border-blue-200 rounded-lg p-4"
      data-tour="upsell-messaging-banner">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-3">
          <div class="text-blue-600">
            <mat-icon>campaign</mat-icon>
          </div>
          <p class="text-blue-900">Automate your upsells: add a Smart Upsell smart code to your messaging rules.</p>
        </div>
        <span
          class="px-4 py-2 text-sm font-medium text-blue-600 hover:text-blue-800 focus:outline-none"
          data-tour="upsell-messaging-cta">
          Edit messaging rules
        </span>
      </div>
    </div>

    <div *ngIf="!loading" class="flex justify-end items-center">
      <sbnb-button size="mini" *ngIf="productCategories?.length" (click)="addNewClicked()">+ Add product</sbnb-button>
    </div>

    <mat-spinner *ngIf="loading" [diameter]="30"></mat-spinner>

    <ng-container *ngIf="!loading">
      <sbnb-no-items
        *ngIf="!productCategories || productCategories.length === 0"
        icon="category"
        text="Let's set up some products that you can offer to your guests."
        [buttons]="[{ id: 'new', label: 'Get started with Upsells' }]"
        (button)="getStartedClicked()"></sbnb-no-items>

      <div *ngIf="productCategories?.length > 0" class="product-catalog__container">
        <!--
        <div class="mb-12 mt-10">
          <div class="stats" fxLayout fxLayoutGap="24px" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
            <div class="stats-box text-center space-y-1" fxFlex>
              <h4>Revenue</h4>
              <h1>$1,598</h1>
              <h5>Last 30 days</h5>
            </div>

            <div class="stats-box text-center space-y-1" fxFlex>
              <h4>Revenue</h4>
              <h1>$28,347</h1>
              <h5>All time</h5>
            </div>

            <div class="stats-box text-center space-y-1" fxFlex>
              <h4>Reservations</h4>
              <h1>14</h1>
              <h5>Last 30 days</h5>
            </div>

            <div class="stats-box text-center space-y-1" fxFlex>
              <h4>Reservations</h4>
              <h1>202</h1>
              <h5>All time</h5>
            </div>
          </div>
        </div>
      -->
        <div *ngFor="let category of productCategories" class="product-category">
          <h3 class="mb-5">{{ category.name }}</h3>

          <div fxLayout fxLayoutGap="18px" fxHide.lt-md class="product-catalog__product-header">
            <div fxFlex="32px">Status</div>
            <div fxFlex>Product Name</div>
            <div fxFlex="120px">Hosts</div>
            <div fxFlex="120px">Properties</div>
            <div fxFlex="112px">Platforms</div>
          </div>

          <a
            *ngFor="let item of category.products"
            fxLayout
            class="product-catalog__product-container"
            fxLayoutAlign="start center"
            fxLayoutGap="18px"
            [routerLink]="[item.id]">
            <mat-slide-toggle
              [checked]="item.active"
              (click)="$event.stopPropagation()"
              (change)="activateOrDeactivateProduct(item, $event)"></mat-slide-toggle>

            <div fxFlex fxHide.lt-md class="product__title ellipsis">
              {{ item.private_name }}
            </div>

            <div fxHide.gt-sm class="product__title ellipsis cera-heading" fxFlex>
              {{ item.private_name }}
            </div>

            <div fxHide.lt-md fxFlex="120px" fxLayoutAlign="start center" fxLayoutGap="8px">
              <sbnb-hosts
                [allHosts]="item.all_hosts"
                [hosts]="item.host_list"
                [ruleName]="item.private_name"></sbnb-hosts>
            </div>

            <div
              fxFlex="none"
              fxFlex.gt-sm="120px"
              fxLayoutAlign="start center"
              fxLayoutGap="8px"
              fxLayoutAlign.lt-md="end center">
              <sbnb-avatar-group
                [items]="item.property_list"
                [allItems]="item.all_properties"
                [itemsForLabel]="item.private_name"></sbnb-avatar-group>
            </div>

            <div fxFlex="112px" fxHide.lt-md fxLayoutGap="8px" fxLayoutAlign="start center">
              <sbnb-scoping-icons
                class="hidden md:flex"
                [showTooltips]="false"
                [scoped]="[
                  (item | doesRuleHavePlatform: 'direct') ||
                  (item | doesRuleHavePlatform: 'manual') ||
                  (item | doesRuleHavePlatform: 'gvr')
                    ? 'hospitable'
                    : null,
                  (item | doesRuleHavePlatform: 'airbnb') ? 'airbnb' : null,
                  (item | doesRuleHavePlatform: 'homeaway') ? 'homeaway' : null,
                  (item | doesRuleHavePlatform: 'booking') ? 'booking' : null
                ]"></sbnb-scoping-icons>
            </div>
          </a>
        </div>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
